import { post, get } from '../utils/fetch';

// 公司简介的API
export default class companyIntroService {
    // 荣誉奖项1列表
    static fetchAwardsOneList(params) {
        return post('/api/v1/dynamic/query', params)
    }
    // 荣誉奖项2列表
    static fetchAwardsTwoList(params) {
        return post('/api/v1/dynamic/query', params)
    }
    // 政府合作项目
    static fetchGoverCoProject(params) {
        return post('/api/v1/dynamic/query', params)
    }
}




// WEBPACK FOOTER //
// ./src/api/companyIntroService.js